import React from 'react';
import classnames from 'classnames';
import classes from './block-header.scss';
export default class BlockHeader extends React.Component {
  render() {
    const {
      textClassName,
      headerClassName,
      hrClassName,
      id
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: classnames(classes['block-header'], headerClassName),
      id: id
    }, /*#__PURE__*/React.createElement("h3", {
      className: textClassName
    }, this.props.children), /*#__PURE__*/React.createElement("hr", {
      className: hrClassName
    }));
  }
}